export function trackTelemetryEvent(eventName, payload = {}) {
    if (typeof window === 'undefined')
        return;
    // TODO: Replace this with a real analytics client when one is available.
    const detail = {
        eventName,
        payload,
        timestamp: new Date().toISOString(),
    };
    window.dispatchEvent(new CustomEvent('flowdoc:telemetry', { detail }));
}
